// Maps BankID processStatusInfo (hintCode) to user-friendly Swedish failure messages.
export function getBankIdFailureMessage(processStatusInfo?: string | null): {
  title: string;
  text: string;
} {
  switch (processStatusInfo) {
    case "userCancel":
      return {
        title: "BankID-signeringen avbröts",
        text: "Du avbröt BankID-signeringen. Försök igen om du vill fortsätta.",
      };
    case "expiredTransaction":
      return {
        title: "Tiden gick ut",
        text: "BankID-signeringen slutfördes inte i tid. Vänligen försök igen.",
      };
    case "startFailed":
      return {
        title: "BankID kunde inte startas",
        text: "BankID-appen kunde inte startas i tid. Kontrollera att du har BankID installerat och försök igen.",
      };
    case "certificateErr":
      return {
        title: "Problem med ditt BankID",
        text: "Det verkar vara ett problem med ditt BankID-certifikat. Kontrollera att ditt BankID är giltigt och försök igen.",
      };
    case "cancelled":
      return {
        title: "Signeringen avbröts",
        text: "En ny signering startades och ersatte den tidigare. Vänligen försök igen.",
      };
    default:
      return {
        title: "Hoppsan! Något gick fel",
        text: "Det gick inte att slutföra signeringen. Det kan vara för att det tog för lång tid eller för att signeringen avbröts. Försök igen eller kontakta support om problemet kvarstår!",
      };
  }
}
